// Feature flag for the group roll-call / QR check-in work.
//
// Built September 2026 for the FNB Zanzibar group (~200 pax, 12 check-in events).
// The client went with a different solution before it shipped, so the whole
// feature is hidden rather than deleted.
//
// Flip this to true to bring it all back — the events UI, the roster with its
// generated scan codes, the QR code pack and its route, and the dummy-user
// seeding tool. Nothing else needs changing.
//
// What was finished: event management, roster sync with stable per-person codes,
// and the printable QR pack. What was not: the public /scan/:token route, the
// Firestore rules for unauthenticated scanning, the scanner screen itself, and
// the aboard/missing tally. See .context/rollcall-plan.md for the full design.
//
// Firestore data already written by this feature lives under:
//   bookings/{bookingId}/rollcall_events
//   bookings/{bookingId}/rollcall_people
// and seeded app users are tagged `seeded: true` in bookings/{bookingId}/users.
// Hiding the UI does not remove any of that.

export const ROLLCALL_ENABLED = false;
